import { Alert, Box, createStyles, DefaultMantineColor, Image, Stack, Title } from '@mantine/core'
import React from 'react'

import { Feature as FeatureType } from '@/types'

interface WrapperProps {
  children: React.ReactNode
  background?: DefaultMantineColor
}

export function Wrapper({ children, background }: WrapperProps) {
  return background && background !== 'unstyled' ? (
    <Alert color={background}>{children}</Alert>
  ) : (
    <>{children}</>
  )
}

interface Props {
  feature: FeatureType
}

const useStyles = createStyles(theme => ({
  image: {
    maxWidth: '100%',
    height: 'auto',
    borderRadius: theme.radius.md,
    overflow: 'hidden'
  }
}))

export default function Banner({ feature }: Props) {
  const { classes } = useStyles()
  const { config, content, image, title } = feature
  const { background } = config || {}

  return (
    <Wrapper background={background}>
      <Stack mb="md">
        {!!title && <Title order={3}>{title}</Title>}
        {!!image && <Image src={image} alt={title} className={classes.image} />}
        {!!content && <Box dangerouslySetInnerHTML={{ __html: content }} />}
      </Stack>
    </Wrapper>
  )
}
